import { CloseButton, Flex, Image, Select, Spacer, Text, VStack, useColorModeValue as mode } from '@chakra-ui/react';
import { useDispatch } from 'react-redux';
import { addCartItem, removeCartItem } from '../redux/actions/cartActions';
import { useSelector } from 'react-redux';
const CartItem = ({ cartItem }) => {
	const { name, image, price, stock, qty, id, brand } = cartItem;
	const { userInfo } = useSelector((state) => state.user);
	const dispatch = useDispatch();

	return (
		<Flex minWidth='320px' borderWidth='1px' rounded='lg' align='center'>
			<Image rounded='lg' w='120px' h='120px' fit='cover' src={image} fallbackSrc='https://via.placeholder.com/150' />
			<VStack p='2' w='100%' spacing='4' align='stretch'>
				<Flex alignItems='center' justify='space-between'>
					<Text fontWeight='medium'>
						{brand} {name}
					</Text>
					<Spacer />
					<CloseButton onClick={() => dispatch(removeCartItem(id))} />
				</Flex>
				<Spacer />
				<Flex alignItems='center' justify='space-between'>
					<Select
						maxW='68px'
						focusBorderColor={mode('red.500', 'red.200')}
						value={qty}
						onChange={(e) => {
							dispatch(addCartItem(id, e.target.value));
						}}>
						{[...Array(stock).keys()].map((item) => (
							<option key={item + 1} value={item + 1}>
								{item + 1}
							</option>
						))}
					</Select>
					{userInfo ? <Text fontWeight='bold'>Ft {price}</Text> : <Text>Jelentkezz be!</Text>}
				</Flex>
			</VStack>
		</Flex>
	);
};

export default CartItem;